import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import qString from "query-string";
import * as actionTypes from "../../../store/actions/actionTypes";
import Loader from "../../Common/Loader/";

const VendorCategoryPagination = (props) => {
  const [jumpTo, setJumpTo] = useState("");
  const [isLoader, setLoader] = useState(false);
  const [paginationOn, setPaginationOn] = useState("");

  useEffect(() => {
    const defaulPageNumber = Boolean(qString.parse(props.location.search).p)
      ? Number(qString.parse(props.location.search).p)
      : 1;
    setPaginationOn(defaulPageNumber);
  }, [props.location]);

  const urlPrev = () => {
    if (paginationOn - 1 <= 1) {
      return props.location.pathname;
    } else {
      let link = `${props.location.pathname}${props.location.search}`;
      link = link.replace(/p=\d+/, `p=${paginationOn - 1}`);
      return link;
    }
  };

  const urlNext = () => {
    if (props.location.search) {
      if (props.location.search.includes("p=")) {
        let link = `${props.location.pathname}${props.location.search}`;
        link = link.replace(/p=\d+/, `p=${paginationOn + 1}`);
        return link;
      } else {
        return `${props.location.pathname}${props.location.search}&p=${
          paginationOn + 1
        }`;
      }
    } else {
      if (props.pagination.num_pages > 1) {
        return `${props.location.pathname}?p=2`;
      } else {
        return `${props.location.pathname}`;
      }
    }
  };

  const urlOnPage = (pageNo) => {
    if (pageNo === 1) {
      return `${props.location.pathname}`;
    } else {
      if (pageNo <= props.vendorCategory.pagination.num_pages) {
        if (props.location.search) {
          if (props.location.search.includes("p=")) {
            let link = `${props.location.pathname}${props.location.search}`;
            link = link.replace(/p=\d+/, `p=${pageNo}`);
            return link;
          } else {
            return `${props.location.pathname}${props.location.search}&p=${pageNo}`;
          }
        } else {
          return `${props.location.pathname}?p=${pageNo}`;
        }
      } else {
        setJumpTo("");
        //alert("Invalid page number entered");
        props.history.push(`${props.location.pathname}`);
      }
    }
  };

  const getURLForAll = (location) => {
    if (location.pathname.includes("/all")) {
      return location.pathname;
    } else {
      return `${location.pathname}/all`;
    }
  };

  return (
    <React.Fragment>
      {isLoader ? (
        <Loader />
      ) : (
        <React.Fragment>
          <div className="pagination">
            {props.vendorCategory.result_count > 15 ? (
              <>
                <div
                  className={
                    paginationOn <= 1 ? "arrow prev disabled" : "arrow prev"
                  }
                >
                  <a
                    href={`${urlPrev()}`}
                    onClick={(e) => {
                      e.preventDefault();
                      if (paginationOn > 1) {
                        props.history.push(urlPrev());
                      } else {
                        alert("You are on first page !");
                      }
                    }}
                  ></a>
                </div>
                <div className="pagination_block">
                  <ul>
                    <li className="active">
                      <a
                        href={urlOnPage(paginationOn)}
                        onClick={(e) => {
                          e.preventDefault();
                          props.history.push(urlOnPage(paginationOn));
                        }}
                      >
                        {paginationOn}
                      </a>
                    </li>
                    {paginationOn <=
                      props.vendorCategory.pagination.num_pages - 1 && (
                      <li>
                        <a
                          href={urlOnPage(paginationOn + 1)}
                          onClick={(e) => {
                            e.preventDefault();
                            props.history.push(urlOnPage(paginationOn + 1));
                          }}
                        >
                          {paginationOn + 1}
                        </a>
                      </li>
                    )}
                    {paginationOn <=
                      props.vendorCategory.pagination.num_pages - 2 && (
                      <li>
                        <a
                          href={urlOnPage(paginationOn + 1)}
                          onClick={(e) => {
                            e.preventDefault();
                            props.history.push(urlOnPage(paginationOn + 2));
                          }}
                        >
                          {paginationOn + 2}
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
                <div
                  className={
                    paginationOn >= props.vendorCategory.pagination.num_pages
                      ? "arrow next disabled"
                      : "arrow next"
                  }
                >
                  <a
                    href={
                      paginationOn >= props.vendorCategory.pagination.num_pages
                        ? null
                        : urlNext()
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      if (
                        paginationOn ===
                        props.vendorCategory.pagination.num_pages
                      ) {
                        alert("You are on last page !");
                      } else {
                        props.history.push(urlNext());
                      }
                    }}
                  ></a>
                </div>
              </>
            ) : null}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

const VendorCategoryPaginationWithRouter = withRouter(VendorCategoryPagination);
const mapStateToProps = (state) => {
  return {
    vendorCategory: state.vendorCategory,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveVendorCommonData: (data) =>
      dispatch({ type: actionTypes.ADDMORE_TO_CATEGORY_LIST, payload: data }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorCategoryPaginationWithRouter);
